<template>
    <div @click.stop="handleClick" class="guid link-button" :title="'点击复制：' + text">{{ text }}</div>
</template>

<script>
export default {
    name: "Guid",
    props: {
        text: {
            type: String,
            required: true,
        },
    },
    methods: {
        handleClick() {
            const input = document.createElement("input");
            input.style.opacity = "0";
            document.body.appendChild(input);
            input.setAttribute("value", this.text);
            input.select();
            if (document.execCommand("copy")) {
                document.execCommand("copy");
                this.$success("复制成功");
            }
            document.body.removeChild(input);
        },
    },
};
</script>

<style scoped>
.guid {
    width: 100%;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
